import { PaymentProcessStatus } from '../../stripe-payment.model';

export const FEATURE_NAME = '@vshosting/libs/stripe-payment/overlay-dialog';

export const PendingStatuses: PaymentProcessStatus[] = [
  PaymentProcessStatus.AwaitingConfirmation,
  PaymentProcessStatus.CheckingPayment
] as const;
